import { z } from 'zod';


export const roleSchema = z.object({
  name: z.string()
    .min(1, 'authorization:roles.validation.nameRequired')
    .max(50, 'authorization:roles.validation.nameMaxLength'),
  description: z.string()
    .max(200, 'authorization:roles.validation.descriptionMaxLength')
    .optional(),
});

export type RoleFormData = z.infer<typeof roleSchema>;
